<!--
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-03-10 14:06:04
-->
<template>
  <div class="player-container">
    <!-- <div class="poster">
      <img :src="player.icon" alt="logo">
    </div> -->
    <div class="content">
      <p>姓名：{{player.name}}</p>
      <p>电话：{{player.phone}}</p>
      <p>性别：{{player.gender}}</p>
      <!-- TODO: 到底要不要？ -->
      <!-- <p>所属工会：{{player.org}}</p> -->
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    player () {
      const playerInfoFromStorage = JSON.parse(localStorage.getItem('PersonInfo'))
      if (!playerInfoFromStorage) {
        return {}
      }
      const player = playerInfoFromStorage.user
      if (!player) {
        return {}
      }
      return {
        icon: player.host + player.icon,
        name: player.name,
        phone: player.telephone,
        gender: player.gender === 'male' ? '男' : '女',
        org: player.union ? player.union.title : ''
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.player-container {
  display: flex;
  align-items: flex-start;
}

.poster {
  width: 120px;
  height: 139px;
  border-radius: 4px;
  background: #dcdfe6;
  border: 1px solid #DCDFE6;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.content {
  margin-left: 26px;
  text-align: left;
  p {
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    color: #4E5A73;
    line-height: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/player-info/index.vue